import React from 'react';
import { Link } from 'react-router-dom';
import { FiMail, FiPhone } from 'react-icons/fi';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    work: [
      { name: 'Platform', path: '/platform' },
      { name: 'Services', path: '/services' },
      { name: 'Projects', path: '/projects' },
    ],
    company: [
      { name: 'About', path: '/about' },
      { name: 'Contact', path: '/contact' },
      { name: 'Careers', path: '/careers' },
    ],
    legal: [
      { name: 'Privacy', path: '/privacy' },
      { name: 'Terms', path: '/terms' },
    ]
  };

  return (
    <footer className="bg-primary-900 text-white">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <img 
                src="/DarkNavLogo.png" 
                alt="DigitalShark" 
                className="h-12 w-auto"
              />
            </div>
            <p className="text-gray-300 mb-6">
              Capturing, streaming, and celebrating Barbados through innovative video technology and production solutions.
            </p>
          </div>

          {/* Work Links */}
          <div>
            <h3 className="font-semibold text-lg mb-6">Work</h3>
            <ul className="space-y-3">
              {footerLinks.work.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path}
                    className="text-gray-300 hover:text-accent-400 transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="font-semibold text-lg mb-6">Company</h3>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path}
                    className="text-gray-300 hover:text-accent-400 transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Information */}
          <div>
            <h3 className="font-semibold text-lg mb-6">Contact</h3>
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <FiPhone className="text-accent-400" size={16} />
                <span className="text-gray-300">{process.env.REACT_APP_CONTACT_PHONE || '+1-265-250-0424'}</span>
              </div>
              <div className="flex items-center space-x-3">
                <FiMail className="text-accent-400" size={16} />
                <span className="text-gray-300">{process.env.REACT_APP_CONTACT_EMAIL || 'admin@digitalshark.tv'}</span>
              </div>
            </div>
            
            <div className="mt-8">
              <h4 className="font-semibold mb-4">Legal</h4>
              <ul className="space-y-2">
                {footerLinks.legal.map((link) => (
                  <li key={link.name}>
                    <Link 
                      to={link.path}
                      className="text-gray-300 hover:text-accent-400 transition-colors duration-200 text-sm"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Call to Action Section */}
        <div className="border-t border-gray-800 mt-12 pt-12">
          <div className="text-center max-w-4xl mx-auto">
            <h3 className="text-2xl md:text-3xl font-bold mb-4">
              Ready to broadcast your next big event?
            </h3>
            <p className="text-gray-300 text-lg mb-8">
              Partner with Digital Shark Inc. and bring your story to the world.
            </p>
            <Link 
              to="/contact" 
              className="inline-block bg-accent-500 hover:bg-accent-600 text-white font-semibold px-8 py-3 rounded-lg transition-colors duration-200"
            >
              Get Started Today
            </Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © {currentYear} DigitalShark — All Rights Reserved
            </p>
            <div className="flex items-center space-x-2 mt-4 md:mt-0">
              <span className="text-gray-400 text-sm">Go Beyond.</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
